import classNames from 'classnames';
export default function ChevronDownIcon({ size = 24, color, className }) {
    return (<svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={classNames('fill-current', className, color)}>
      <path fillRule="evenodd" clipRule="evenodd" d="M7.529 11.138c.26.26.682.26.942 0l4.667-4.666a.667.667 0 0 0-.943-.943L8 9.724 3.805 5.529a.667.667 0 1 0-.943.943l4.667 4.666Z" fill="currentColor"/>
    </svg>);
}
